import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    courseData: {
      required: true,
      type: Object
    },
    showLabel: {
      required: false,
      type: Boolean,
      default: false
    },
    labelContent: {
      required: false,
      type: String,
      default: 'course_type_name'
    },
    cols: {
      required: false,
      type: String,
      default: 'n + 3'
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number
  },
  methods: {
    goDetail() {
      if (this.authType == 2 && !this.userInfo) {
        handleLogin();
      } else {
        window.location.href = this.courseData.course_url;
      }
    }

  }
};